/* eslint-disable import/no-anonymous-default-export */
import base from '../base';

export default {
	styleOverrides: {
		// The red belongs to the .Mui-error state, not to the root: on
		// the root it painted every helper string in the product red
		// whether or not anything was wrong, and made error={...} a
		// no-op everywhere -- a control in error looked exactly like one
		// at rest. text.hint is what typography.caption already uses.
		root: {
			color: base.palette.text.hint,
			marginInlineStart: 0,
			'&.Mui-error': {
				color: base.palette.error.main,
			},
		},
	},
};
